import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import ContentWrapper from '../components/contentwrapper/ContentWrapper'
import { Link } from 'react-router-dom'
import { AiFillDelete, AiFillEdit, AiOutlinePlus } from 'react-icons/ai'
import Swal from 'sweetalert2'
import { activeStatus, fetchHrDataFromSuperAdmin, removeDataFromList } from '../utils/api'
import { toast } from 'react-toastify'
import LoadingSpinner from '../components/LoadingSpinner'

const MIS = () => {
    const [misdata, setmisdata] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const BASE_URLS = "https://backend.satkartar.org/assets/mis/";

    useEffect(() => {
        getHrData();
    }, [])
    const getHrData = () => {
        setIsLoading(true);
        try {
            fetchHrDataFromSuperAdmin('super-admin-all-mis').then((res) => {
                if (res.data.status === 1) {
                    setmisdata(...[res.data.misdata]);
                    setIsLoading(false)
                }
                else {
                    toast.error("Something Wrongs");
                    setIsLoading(false);
                }
            })
        }
        catch (error) {
            toast.error("Something Wrongs");
            setIsLoading(false);
        }
    }
    const handleMisActive = (misid) => {
        activeStatus('super-admin-active-mis-status', misid).then((res) => {
            if (res.data.status === 1) {
                getHrData();
            }
        })
    }
    const handleMisInactive = (misid) => {
        activeStatus('super-admin-inactive-mis-status', misid).then((res) => {
            if (res.data.status === 1) {
                getHrData();
            }
        })
    }
    const handleMisRemoveMis = (misid) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'danger',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
        }).then((result) => {
            if (result.isConfirmed) {
                removeDataFromList('super-admin-remove-mis', misid).then((res) => {
                    if (res.data.status === 1) {
                        Swal.fire(
                            'Deleted!',
                            'Your file has been deleted.',
                            'success'
                        )
                        getHrData();
                    }
                })
            }
            else if (
                result.dismiss === Swal.DismissReason.cancel
            ) {
                Swal.fire(
                    'Cancelled',
                    'Your imaginary file is safe :)',
                    'error'
                )
            }
        })
    }
    return (
        <div className="hrpage">
            <Helmet>
                <title>SATKARTAR:ADMIN::MIS</title>
            </Helmet>

            <ContentWrapper>
                <div className="card hrpages">
                    <h4 className="mb-0 text-uppercase">
                        All MIS
                        <Link to="/add-mis" className="btn btn-primary pull-right"><AiOutlinePlus /> Add MIS</Link>
                    </h4>
                    <div className="table pagetable table-responsive">
                        <table id="example" className="table table-striped" style={{ width: "100%" }}>
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Image</th>
                                    <th>Name</th>
                                    <th>Email</th>
                                    <th>Mobile</th>
                                    <th>Last Login</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {isLoading ? <LoadingSpinner />
                                    :
                                    misdata?.map((misdata, index) => (
                                        <tr key={misdata?.mis_id}>
                                            <td>{index + 1}</td>
                                            <td><img width="50" height="50" style={{ width: "50px" }} src={BASE_URLS + misdata?.mis_foto} alt={misdata?.mis_foto} /></td>
                                            <td>{misdata?.mis_name}</td>
                                            <td>{misdata?.mis_email}</td>
                                            <td>{misdata?.mis_mobile}</td>
                                            <td>{misdata?.mis_last_login}</td>
                                            <td>
                                                {(() => {
                                                    if (misdata?.mis_status === "Active") {
                                                        return (
                                                            <span className="badge bg-success hrstatus" onClick={() => handleMisActive(misdata?.mis_id)}>Active</span>
                                                        )
                                                    }
                                                    else {
                                                        return (
                                                            <span className="badge bg-danger hrstatus" onClick={() => handleMisInactive(misdata?.mis_id)}>Inactive</span>
                                                        )
                                                    }
                                                })()}
                                            </td>
                                            <td>
                                                <Link to={`/edit-mis/${misdata?.mis_id}`} className="btnEdit"><AiFillEdit /></Link>
                                                <button className="btnDelete" onClick={() => handleMisRemoveMis(misdata?.mis_id)}><AiFillDelete /></button>
                                            </td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th>#</th>
                                    <th>Image</th>
                                    <th>Name</th>
                                    <th>Email</th>
                                    <th>Mobile</th>
                                    <th>Last Login</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </ContentWrapper>

        </div>
    )
}

export default MIS